// extracted by mini-css-extract-plugin
export default {"textAreaComponent":"_1TrL6kuqyrxKxJvwk8nh7w","label":"piFXimC7mKmER4crJbrT7","alternativeLabel":"_1rNie9tOaKtAM74p_uPslp"};